import React from "react"
import { dateFormatter, formatSize } from "ui"
import { IFile } from "ui/components/File/TypeFile"

interface FileInfoProp {
    file?: IFile
}

export function FileInfo({
    file
}: FileInfoProp) {

    let lastModified = '--/--/----'
    if(file?.lastModified) {
        lastModified = dateFormatter(new Date(file.lastModified))
    } else if(file?.dateUpdated) {
        lastModified = dateFormatter(new Date(file.dateUpdated))
    }

    let extension = 'ND'
    if(file?.extension) {
        extension = file.extension
    } else if(file?.ext) {
        extension = file.ext
    }

    // Refonte « Aurora » : fiche du fichier en carte, lignes clé / valeur séparées par des filets
    return (
        <div className="flex flex-col text-[13px] rounded-2xl bg-white dark:bg-color8 ring-1 ring-ink/[0.06] dark:ring-white/10 shadow-soft divide-y divide-line/80 dark:divide-color7 overflow-hidden">
            <div className="flex items-center gap-3 px-4 py-2.5">
                <div className="flex-1 text-slate-500 dark:text-color4">Extension</div>
                <div className="px-2 py-0.5 rounded-full bg-brand-50 dark:bg-color7 text-brand-700 dark:text-white text-xs font-semibold">{extension}</div>
            </div>
            <div className="flex items-center gap-3 px-4 py-2.5">
                <div className="flex-1 text-slate-500 dark:text-color4">Taille</div>
                <div className="font-semibold text-ink dark:text-white tabular-nums">{file?.size ? formatSize(file.size) : 'ND'}</div>
            </div>
            <div className="flex items-center gap-3 px-4 py-2.5">
                <div className="flex-1 text-slate-500 dark:text-color4">Modification</div>
                <div className="font-semibold text-ink dark:text-white tabular-nums">{lastModified}</div>
            </div>
        </div>
    )
}
